import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function RequireSubscription({ children }) {
  const { isAuthed, loading } = useAuth();
  const [state, setState] = useState({ checking: true, active: false });
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!isAuthed) {
      setState({ checking: false, active: false });
      return;
    }
    api.get("/billing/me").then((r) => {
      setState({ checking: false, active: !!r.data.active });
    }).catch(() => setState({ checking: false, active: false }));
  }, [isAuthed, loading]);

  // Spinner covers BOTH the initial /auth/me probe AND the /billing/me check
  // so users never see a redirect flash while either request is in flight.
  if (loading || state.checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F6F2]" data-testid="require-sub-loading">
        <div className="w-10 h-10 rounded-full border-2 border-[#2C4C3B] border-t-transparent animate-spin" />
      </div>
    );
  }
  // Preserve the user's intended destination so /login?next=... can bounce
  // them right back after they sign in — better UX than dumping them on the
  // landing page and making them re-navigate.
  if (!isAuthed) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (!state.active) return <Navigate to="/subscribe" replace />;
  return children;
}
